<template>
    <rkm-modal
        extra-large
        hide-footer
        ref="RkmModal"
        title="Agendamento de exame"
    >
        <List
            @create="create"
            is-modal
        />

        <Modal
            v-if="id"
            :paciente-id="id"
            :hasAmbulatorio="true"
            @save="handleSave"
            ref="Modal"
        />
    </rkm-modal>
</template>

<script>
// Components.
import List from '@/components/exame-laboratorial/agendamento-exame/List'
import Modal from '@/components/exame-laboratorial/agendamento-exame/Modal'

export default {
    components: {
        List,
        Modal,
    },
    data: () => ({
        id: null,
    }),
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
        create(id) {
            this.id = id
            this.$nextTick().then(() => this.$refs.Modal.open())
        },
        handleSave() {
            this.id = null
            this.showSaveNotification()
            this.$refs.RkmModal.hide()
        },
    },
}
</script>